var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTickMark = function SvgTickMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 2.25A6.752 6.752 0 0 0 2.25 9 6.752 6.752 0 0 0 9 15.75 6.752 6.752 0 0 0 15.75 9 6.752 6.752 0 0 0 9 2.25ZM9 14.4A5.407 5.407 0 0 1 3.6 9c0-2.977 2.423-5.4 5.4-5.4 2.977 0 5.4 2.423 5.4 5.4 0 2.977-2.423 5.4-5.4 5.4Zm2.619-7.904L7.65 10.465l-1.269-1.27a.672.672 0 1 0-.952.953l1.748 1.748a.672.672 0 0 0 .952 0l4.449-4.449a.672.672 0 0 0 0-.951.68.68 0 0 0-.959 0Z",
    fill: "#4CAB78"
  })));
};
export default SvgTickMark;